export default "__VITE_ASSET__BxLbEcFr__"